import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reject",
  "use": "icon-reject-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-reject\"><path d=\"M2.93 17.072a10 10 0 100-14.143 10 10 0 000 14.143zm12.628-1.515a7.864 7.864 0 01-10.35.664L16.223 5.207a7.864 7.864 0 01-.665 10.35zM4.448 4.443a7.864 7.864 0 0110.35-.664L3.78 14.793a7.864 7.864 0 01.668-10.35z\" fill=\"#f34686\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol